import { useContext, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import { PlacementSummary } from '@Components/CreativeAllocation';
import { ToggleSwitch } from '@Components/ToggleSwitch';
import { EditableCard } from './Cards';
import { PieSetter } from './PieSetter';
import { StreamingCreativesContext } from './streaming-creatives-constants';
import { getCurrentCompanion } from './streaming-creatives-utils';

export const Workspace = () => {
  const {
    adServer,
    audioCompanionOptions,
    date,
    dimensions,
    flashtalkingPlacementType,
    length,
    platform,
    selectedMap,
    setWorkspaceMetadata,
    setWorkspaceValue,
    shopData,
    workspaceMap,
    workspaceMetadataMap,
    workspaceOptions
  } = useContext(StreamingCreativesContext);

  const [showAllCreatives, setShowAllCreatives] = useState(false);

  const visibleOptions = useMemo(
    () => workspaceOptions.filter(opt => showAllCreatives || !opt.reason),
    [workspaceOptions, showAllCreatives]
  );

  const selectedIds = useMemo(
    () => Object.keys(selectedMap).filter(id => selectedMap[id]),
    [selectedMap]
  );

  return (
    <div className='workspace'>
      <Card className='workspace-card'>
        <div className='workspace-toolbar'>
          <PlacementSummary
            platform={platform}
            placementType={flashtalkingPlacementType}
            length={length ?? undefined}
            dimensions={dimensions || undefined}
            date={date}
          />
          <ToggleSwitch
            label='Show all creatives'
            checked={showAllCreatives}
            onChange={setShowAllCreatives}
            infoTooltipText='Show creatives that are ineligible for this placement, disabled with the reason why.'
          />
        </div>
        <div className='workspace-card-inner'>
          <PieSetter
            pieFlex={0.5}
            data={visibleOptions.map(opt => ({
              ...opt,
              key: opt.isci,
              value: workspaceMap[opt.isci] || 0,
              disabled: Boolean(opt.reason),
              disabledReason: opt.disabledReason,
              clickthroughURL: workspaceMetadataMap[opt.isci]?.clickthroughURL,
              audioCompanion: workspaceMetadataMap[opt.isci]?.audioCompanion,
              currentCompanion: getCurrentCompanion(shopData.placementMap, selectedIds, opt.isci)
            }))}
            renderItem={elem => (
              <EditableCard
                {...elem}
                onChange={setWorkspaceValue}
                onMetadataChange={setWorkspaceMetadata}
                audioCompanionOptions={audioCompanionOptions}
                adServer={adServer}
              />
            )}
          />
        </div>
      </Card>
    </div>
  );
};
